<template>
  <div>
    <div class="col-sm-12 col-xs-12 col-md-12 tour-hr">
      <hr/>
    </div>
    <div class="col-sm-12 col-md-12 col-xs-12 pl-32">
      <div class="virtual-tour-content">
     {{ $t('virtualTourContent')}}
      </div>
      <button @click="openTour()" class="btn start-virtual-tour-btn">
        <img class="tour-icon" src="/static/images/icons/virtual_tour_white_icon.svg" />
        <span class="start-tour">{{ $t('startTour')}}</span>
      </button>
    </div>
  </div>
</template>

<script>
import EventBus from '../../utils/event-bus';

export default {
  data() {
    return {};
  },
  methods: {
    openTour() {
      this.$emit('closepopup');
      EventBus.$emit('displayTour');
    },
  },
};
</script>

<style scoped>
.tour-hr hr{
  border-top: 0.5px solid #828282;
  opacity: 0.4;
  margin-top: 12px;
  margin-bottom: 0px;
}
.tour-hr{
  padding-left: 24px;
  padding-right: 24px;
}
.pl-32{
  padding-left: 32px;
}
.start-virtual-tour-btn, .start-virtual-tour-btn:hover {
    background-color: #01518A;
    border: none;
    cursor: pointer;
    min-width: 160px;
    color: #ffffff;
    line-height: 25px;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    margin-top: 32px;
    padding: 6px 16px;
}
.text_align_center {
  text-align: center;
}
.market_place_img {
  width: 18%;
  margin-top: 7%;
}
.cursor-pointer {
  cursor: pointer;
}
.tour-button {
  Width :185px;
  margin-top: 24px;
}
.tour-icon {
  padding-right: 8px;
  padding-bottom: 4px;
  width: 21px;
}
.start-tour {
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  color: #ffffff;
  font-family: 'Open Sans';
}
.virtual-tour-content {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  color: #333333;
  width: 409px;
  margin-top: 25px;
  /* padding-left: 10px; */
}
</style>
